import React, { useContext, useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Context } from "../Context/AuthContext";
import Loader from "../common/Loader";

const RequiredAuth = () => {
  const { values, isLog } = useContext(Context);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const loadingDelay = setTimeout(() => {
      if (values?.UserInfo?.userInfo) {
        setUserRole(values.UserInfo.userInfo.role);
      }
      setLoading(false);
    }, 1000);

    return () => clearTimeout(loadingDelay);
  }, [values]);

  if (loading) {
    return <Loader />;
  }

  const isUserAuthorized = userRole === "admin" && isLog === true;

  return isUserAuthorized ? <Outlet /> : <Navigate to='/unauthorized' />;
};

export default RequiredAuth;
